import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'icon-microphone',
  templateUrl: './icon-microphone.component.html',
  styleUrls: ['./icon-microphone.component.scss'],
})
export class IconMicrophoneComponent  implements OnInit {
  @Input() size :number = 20;
  constructor() { }

  ngOnInit() {}

}
